const openWindowWithExternalLink = link => {
  window.open(link);
};

const getDropDownSiteOptions = sites =>
  sites
    .filter(site => site.hasContentPreview)
    .map(site => ({ id: site.param, name: site.name }));

export { openWindowWithExternalLink, getDropDownSiteOptions };
